import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { FORMATS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { GEO_APIs } from "../../../apihandlers/geography";
import { PRODUCT_APIs } from "apihandlers/product";
import { DateFunctions } from "common/datefunctions";

const Price = (props: any) => {
  const { setDashMenu } = props;

  const stateRef: any = useRef(null);
  const boxRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [states, setStates] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [box, setBox] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getStates();
    }
  }, [loading]);

  const getStates = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getStates(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.stateName,
          };
        });
        setStates(list);
        getProductsSku();
      }
    });
  };
  const getProductsSku = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    PRODUCT_APIs.getProductsSku(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.mainProduct,
          };
        });
        setBox(list);
        getRows();
      }
    });
  };
  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await PRODUCT_APIs.getPrices(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getPrices:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "skuName",
      name: LABELS.BOX,
      width: "20%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "stateName",
      name: LABELS.STATE,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "orgName",
      name: LABELS.ORGANIZATION,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "fromDt",
      name: LABELS.FROM_DATE,
      width: "10%",
      type: "date",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "toDt",
      name: LABELS.TO_DATE,
      width: "10%",
      type: "date",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "piecePrice",
      name: LABELS.PIECE_PRICE,
      width: "10%",
      type: "number",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "boxPrice",
      name: LABELS.BOX_PRICE,
      width: "10%",
      type: "number",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const managePrice = () => {
    const skuId = boxRef.current.selectedValue.id;
    const stateId = stateRef.current.selectedValue.id;
    const fromDt = (
      document.getElementById("from") as HTMLInputElement
    ).value.trim();
    const toDt = (
      document.getElementById("to") as HTMLInputElement
    ).value.trim();
    const piecePrice = (
      document.getElementById("piecePrice") as HTMLInputElement
    ).value.trim();
    const boxPrice = (
      document.getElementById("boxPrice") as HTMLInputElement
    ).value.trim();

    // Validations
    let errors = [];
    if (!stateId) {
      errors.push({
        id: "stateId",
        msg:
          "<span class='bold'>" +
          LABELS.STATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!skuId) {
      errors.push({
        id: "skuId",
        msg:
          "<span class='bold'>" +
          LABELS.BOX +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (fromDt === "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!piecePrice) {
      errors.push({
        id: "piecePrice",
        msg:
          "<span class='bold'>" +
          LABELS.PIECE_PRICE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!boxPrice) {
      errors.push({
        id: "boxPrice",
        msg:
          "<span class='bold'>" +
          LABELS.BOX_PRICE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      skuId,
      stateId,
      fromDt,
      toDt,
      piecePrice,
      boxPrice,
    };
    console.log("args", args);
    setIsSubmit(true);
    PRODUCT_APIs.managePrice(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.PRICE}</li>
        </ul>
        <h4>{TITLES.PRICE}</h4>
        <p>{SUB_TITLES.PRICE}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.PRICE}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.PRICE + ": " + selectedRow.skuName
              : "Add New " + LABELS.PRICE
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <label>
              {LABELS.STATE}
              {<span className="red">*</span>}
            </label>
            <AutoComplete
              list={states}
              childRef={stateRef}
              defaultValue={
                selectedRow.id
                  ? {
                      id: selectedRow.stateId,
                      label: selectedRow.stateName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.BOX}
              {<span className="red">*</span>}
            </label>
            <AutoComplete
              list={box}
              childRef={boxRef}
              defaultValue={
                selectedRow.skuId
                  ? {
                      id: selectedRow.skuId,
                      label: selectedRow.skuName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup required">
            <TxtRow
              id={"from"}
              type={"date"}
              label={LABELS.FROM_DATE}
              defaultValue={
                selectedRow.ldDate
                  ? DateFunctions.getFormatedDate(
                      selectedRow.ldDate,
                      FORMATS.SQL_DATE,
                      FORMATS.SQL_DATE_ONLY
                    )
                  : DateFunctions.getDate(
                      "today",
                      "from",
                      FORMATS.SQL_DATE_ONLY
                    )
              }
              disabled={isSubmit}
              required={true}
            />
          </div>

          <div className="formGroup required">
            <TxtRow
              id={"to"}
              type={"date"}
              label={LABELS.TO_DATE}
              defaultValue={
                selectedRow.ldDate
                  ? DateFunctions.getFormatedDate(
                      selectedRow.ldDate,
                      FORMATS.SQL_DATE,
                      FORMATS.SQL_DATE_ONLY
                    )
                  : DateFunctions.getDate(
                      "today",
                      "from",
                      FORMATS.SQL_DATE_ONLY
                    )
              }
              disabled={isSubmit}
              required={true}
            />
          </div>

          <div className="formGroup red">
            <TxtRow
              id={"piecePrice"}
              type={"number"}
              label={LABELS.PIECE_PRICE}
              defaultValue={
                selectedRow.id
                  ? Number(selectedRow.piecePrice).toString()
                  : selectedRow.piecePrice
              }
              disabled={isSubmit}
              required={true}
            />
          </div>

          <div className="formGroup red">
            <TxtRow
              id={"boxPrice"}
              type={"number"}
              label={LABELS.BOX_PRICE}
              defaultValue={
                selectedRow.id
                  ? Number(selectedRow.boxPrice).toString()
                  : selectedRow.boxPrice
              }
              disabled={isSubmit}
              required={true}
            />
          </div>
          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="formGroup submitBtnWrapper">
            <div className=" flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={managePrice}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Price);
